import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';

import Row from './RainInfoRowComponent';

const styles = theme => ({
    headerGrid: {
        paddingTop: '2rem',
        paddingLeft: '1rem',
        textAlign: 'center'
    },
    paper: {
        maxWidth: '1005px',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(1),
        border: '5px solid #000'
    },
    container: {
        maxHeight: 540,
    },
    th: {
        backgroundColor: '#0F7DB0'
    },
    th_text: {
        color: theme.palette.common.white,
        fontWeight: 'bold'
    },
})

class RainInfoTableComponent extends React.Component {
    render() {
        const { classes } = this.props

        return (
            <Grid container direction="row">
                <Grid item xs={12} className={classes.headerGrid}>
                    <Typography variant="h4">
                        Today & Yesterday Info
                    </Typography>
                </Grid>

                <Grid item xs={12} style={{ padding: '1rem' }}>
                    <Paper className={classes.paper}>
                        {this.props.data.length ?
                            <TableContainer className={classes.container}>
                                {this.props.data.map(x => (
                                    <Table size="small" aria-label="rain-info"
                                        key={x.idx}>

                                        <TableHead className={classes.th}>
                                            <TableRow>
                                                <TableCell colSpan={4}
                                                    className={classes.th_text}>
                                                    {x.location}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            <Row row={x} />
                                        </TableBody>

                                    </Table>
                                ))}
                            </TableContainer>
                            :
                            <Grid container alignItems="center" justify="center">
                                <CircularProgress />
                            </Grid>
                        }
                    </Paper>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles, { withTheme: true })(RainInfoTableComponent);